import { useHttp } from '../http'

export const useGoalHttp = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`goals`, payload)
    }

    return {
        get,
    }
}